module.exports = __webpack_public_path__ + "static/media/Hero.096e527d.png";